module.exports = __webpack_public_path__ + "img/Colocation.b78a75b.svg";